import React from "react";

const GoogleAds = () => {
  return (
    <ins className='dcmads' style={{display:"inline-block", width:"300px",height:"250px"}} data-dcm-placement='N510001.4053507OPSSHOPTEST/B25402959.305557063' data-dcm-rendering-mode='iframe' data-dcm-gdpr-applies='gdpr=${GDPR}' data-dcm-gdpr-consent='gdpr_consent=${GDPR_CONSENT_755}' data-dcm-addtl-consent='addtl_consent=${ADDTL_CONSENT}' data-dcm-ltd='false' data-dcm-resettable-device-id='' data-dcm-app-id=''></ins>
  )
}

export default GoogleAds;